'use client';
import { createContext, useCallback, useState } from 'react';

export interface PageState {
  isSorting?: boolean;
  // Outros estados da página poderiam ser adicionados aqui
  // filter?: string;
  // currentPage?: number;
}

export interface AllPagesState {
  [pageName: string]: PageState;
}

type ActionPageContextType = {
  pageStates: AllPagesState;
  setSortingForPage: (page: string, isSorting: boolean) => void;
};

export const ActionPageContext = createContext<
  ActionPageContextType | undefined
>(undefined);

export function ActionPageProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const [pageStates, setPageStates] = useState<AllPagesState>({});

  const setSortingForPage = useCallback((page: string, isSorting: boolean) => {
    setPageStates((prevStates) => ({
      ...prevStates,
      [page]: {
        ...prevStates[page], // Mantém outros estados da página, se houver
        isSorting,
      },
    }));
  }, []);

  const value = { pageStates, setSortingForPage };

  return (
    <ActionPageContext.Provider value={value}>
      {children}
    </ActionPageContext.Provider>
  );
}
